// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"8b08df04","156":"8b08df04","258":"8b08df04","390":"8b08df04","412":"8b08df04","567":"8b08df04","588":"8b08df04","630":"8b08df04","663":"8b08df04","703":"8b08df04","830":"8b08df04"}[chunkId] + ".chunk.css";
};